import { FlaskConical, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

import { api } from "@/api";

// Fiche TEST isolée : jamais envoyée vers noCRM, exclue des statistiques, supprimable en 1 clic
export function TestLeadSection() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/pipeline/test-lead").then(({ data }) => setSt(data)).catch(() => {}); }, []);
  const run = async (method) => {
    setBusy(true);
    try { setSt((await api[method]("/pipeline/test-lead")).data); toast.success(method === "post" ? "Fiche TEST créée." : "Fiche TEST supprimée."); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur, réessayez."); } finally { setBusy(false); }
  };
  if (!st) return null;
  return (
    <section className="settings-section" data-testid="test-lead-section">
      <div className="section-title"><FlaskConical size={20} /><div><p className="eyebrow">FICHE TEST</p><h2>Fiche TEST isolée</h2></div></div>
      <p className="fileprep-dedup-hint">Dans le pipeline Call center LVB, marquée TEST. Rien n'est envoyé vers noCRM et elle n'entre dans aucun compteur, bilan ou statistique.</p>
      <div className="lr-chips">
        {st.exists ? (
          <>
            <Link className="primary-button" to={`/pipeline?lead=${st.lead.lead_id}`} data-testid="test-lead-open">Ouvrir la fiche TEST ({st.lead.step})</Link>
            <button type="button" className="secondary-button" disabled={busy} onClick={() => window.confirm("Supprimer la fiche TEST et tout son historique ?") && run("delete")} data-testid="test-lead-delete"><Trash2 size={14} /> Supprimer</button>
          </>
        ) : <button type="button" className="primary-button" disabled={busy} onClick={() => run("post")} data-testid="test-lead-create">Créer la fiche TEST</button>}
      </div>
    </section>
  );
}
